import { InvalidMineralError } from '../../domain/errors/InvalidMineralError';
import type { MineralsRepository } from '../../domain/repositories/MineralsRepository.interface';
import type { MineralDto } from '../dto/MineralDto';
import { ApplicationError, ValidationError, type Logger } from '@dma/shared';

export class GetMineralBySlugUseCase {
  constructor(
    private readonly repository: MineralsRepository,
    private readonly logger: Logger
  ) {}

  public async execute(slug: string): Promise<MineralDto> {
    let mineral;
    try {
      mineral = await this.repository.getBySlug(slug);
    } catch (error) {
      if (error instanceof InvalidMineralError) {
        this.logger.error('Mineral content failed domain validation', {
          slug,
          code: error.code,
          message: error.message
        });
        throw new ApplicationError('MINERAL_UNAVAILABLE', 'این محصول در حال حاضر در دسترس نیست.', {
          cause: error
        });
      }
      throw error;
    }

    if (!mineral) {
      throw new ValidationError(`محصولی با شناسه‌ی "${slug}" یافت نشد.`);
    }

    return mineral.props;
  }
}
